import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import VueTheMask from 'vue-the-mask'
import './assets/tailwind.css'

Vue.config.productionTip = false

const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.prototype.$axios = axios;

new Vue({
  render: h => h(App),
}).$mount('#app')
